import React, { useState, useEffect } from "react";
import CourseDropdown from "./CourseDropdown.jsx";
import CourseContent from "./CourseContent.jsx";
import CourseQuestion from "./CourseQuestion.jsx";
import { useNavigate, useParams } from "react-router-dom";
import { RiMenuUnfoldLine } from "react-icons/ri";
import { FaRegRectangleXmark } from "react-icons/fa6";
import "./CoursesPage.css";

function CoursesPage() {
  // const coursesName = [ "JAVASCRIPT",  "HTML",  "CSS",  "JAVA",  "PYTHON",  "NODE JS",  "C++",  "C",  "C#",  "RUBY",  "PHP",  "RUST",  "SWIFT",  "KOTLIN",  "SCALA",  "GO",  "R",  "DART",  "RACKET",  "HASKELL",  "F#"];
  const coursesName = [ "JAVASCRIPT",  "HTML",  "CSS"];
  const courseDifficulty = ["Easy", "Medium", "Hard"];

  const [selectedQuestion, setSelectedQuestion] = useState(null);
  const [questionSectionOpen, setQuestionSectionOpen] = useState(false);
  const [defaultCourseParam, setDefaultCourseParam] = useState("");
  const [defaultDifficulty, setDefaultDifficulty] = useState("");
  const [leftPanelOpac, setLeftPanelOpac] = useState(1);

  const { courseParam, difficulty } = useParams();

  const navigator = useNavigate();


  useEffect(() => {
    if (!courseParam) {
      setDefaultCourseParam(coursesName[0]);
    } else {
      setDefaultCourseParam(courseParam);
    }
    // eslint-disable-next-line
  }, [courseParam]);

  // redirecting hook
  useEffect(() => {
    if (!courseParam) {
      navigator(
        `/categories/${coursesName[0].toLowerCase()}/${courseDifficulty[0].toLowerCase()}`
      );
    } else if (!courseParam && !difficulty) {
      navigator(
        `/categories/${courseParam.toLowerCase()}/${courseDifficulty[0].toLowerCase()}`
      );
    }else if (!difficulty) {
      navigator(
        `/categories/${courseParam.toLowerCase()}/${courseDifficulty[0].toLowerCase()}`
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [courseParam, difficulty]);

  useEffect(() => {
    if (!difficulty) {
      setDefaultDifficulty(courseDifficulty[0]);
    } else {
      setDefaultDifficulty(difficulty);
    }
    // eslint-disable-next-line
  }, [difficulty]);

  const handleQuestionSectionToggle = () => {
    setQuestionSectionOpen(!questionSectionOpen);
  };

  useEffect(() => {
  window.innerWidth < 768   &&  handleQuestionSectionToggle()
    // eslint-disable-next-line
  }, [selectedQuestion])
  
  const handleSelectedQuestion = (item) => {
    setSelectedQuestion(item);
  };
  const handleInterMenuIcon = () => {
    setLeftPanelOpac(0.6);
  };

  const handleLeaveMenuIcon = () => {
    setLeftPanelOpac(1);
  };

  return (
    <div className="coursePage flex flex-col lg:flex-row h-[100vh] bg-gray-800">
      <div
        style={{ opacity: `${leftPanelOpac}` }}
        className={`scrollbarHide relative lg:w-1/5 h-[100%]  overflow-y-visible bg-gray-800 ${
          questionSectionOpen ? "questionSectionClose" : "questionSectionOpen"
        }`}
      >
        <CourseDropdown
          courses={coursesName}
          defaultValue={defaultCourseParam}
          identy={"courseDrop"}
        />
        <CourseDropdown
          courses={courseDifficulty}
          defaultValue={defaultDifficulty}
          identy={"difficultyDrop"}
        />
        <CourseQuestion questionSelected={handleSelectedQuestion} />

        <div className="arrowLeftRight hidden absolute top-5 ">
          <span
            onClick={handleQuestionSectionToggle}
            className={`hidden ${questionSectionOpen ? "leftArrow" : ""}`}
          >
            <RiMenuUnfoldLine />
          </span>
          <span
            onClick={handleQuestionSectionToggle}
            className={`hidden xmarkOverideBg ${!questionSectionOpen ? "rightArrow" : ""}`}
          >
            <FaRegRectangleXmark />
          </span>
        </div>
      </div>

      <div
        className={`${
          !questionSectionOpen ? "menuIcon" : "menuIconClose"
        } relative h-12 cursor-pointer mx-0.5 my-auto bg-gray-100 hover:bg-gray-700 rounded-md px-1`}
        onClick={handleQuestionSectionToggle}
        onMouseLeave={handleLeaveMenuIcon}
        onMouseMove={handleInterMenuIcon}
      ></div>

      <div className="rightSectionQuestionContent flex-1  py-2 mr-2 h-full ">
        {/* <div className=" h-28 w-full bg-gray-950"></div> */}{" "}
        {/* enable for ads || promo... */}
        <CourseContent currentQuestion={selectedQuestion} />
      </div>
    </div>
  );
}

export default CoursesPage;
